(() => {
(($, Drupal1, drupalSettings1)=>{
    "use strict";
    const windowWidth = ()=>{
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    };
    // Find
    const findBreakpoint = ()=>{
        var bp, width = windowWidth();
        $.each(drupalSettings1.breakpoints, function(i, val) {
            if (width >= val) {
                bp = i;
                return i;
            }
        });
        return bp;
    };
    //Helper for getting animation duration
    //Drupal.AjaxCommands.prototype.appendListing = function(ajax, response, status){
    Drupal1.AjaxCommands.prototype.appendListing = (ajax, response, status)=>{
        var width = windowWidth(), selector = $(response.selector).addClass("open"), selectorParent = selector.parent(), position = selector.index(), sibling = selectorParent.children(), content_wrapped = $("<div></div>").html(response.data).addClass("ajax-family-list").data("belong", response.selector), bp = findBreakpoint(), remainder, lastList = selectorParent.find(".ajax-family-list");
        if (bp == "treston.xlarge") remainder = 3 - position % 4;
        else if (bp == "treston.medium") remainder = 1 - position % 2;
        else remainder = 0;
        if (lastList.length) {
            if (lastList.index() < position) {
                position -= 1;
                if (bp == "treston.xlarge") remainder = 3 - position % 4;
                else if (bp == "treston.medium") remainder = 1 - position % 2;
                else remainder = 0;
                position += 1;
            }
            if (lastList.data("belong") == response.selector) window.location.hash = null;
            $(lastList.data("belong")).removeClass("open");
            lastList.remove();
        }
        // Adding family id to url so it can be generated on sharing purposes
        window.location.hash = selector[0].id;
        var insertPos = 1 + position + remainder;
        insertPos = insertPos > sibling.length ? sibling.length : insertPos;
        sibling.eq(insertPos - 1).after(content_wrapped);
        Drupal1.attachBehaviors(content_wrapped.get(0), void 0);
    };
    Drupal1.behaviors.expand = {
        attach: (context, settings)=>{
            context.querySelectorAll(".categories .category-title").forEach((flv)=>{
                flv.addEventListener("click", function(e) {
                    $(context.querySelectorAll(".categories .family-listing")).hide();
                    $(context.querySelectorAll(".categories")).removeClass("open");
                    var parentEl = $(this).next().toggle().parent();
                    parentEl.addClass("open");
                    window.location.hash = parentEl.children()[0].id;
                    $("html, body").animate({
                        scrollTop: parentEl.offset().top - 40
                    }, 300);
                });
            });
            var familyListing = $(context.querySelectorAll(".categories .family-listing")).slice(1);
            var processUrl = function(context) {
                var hashed = window.location.hash.slice(1), $context = $(context);
                if (hashed.length > 0) {
                    if (hashed.indexOf("family") > -1 || hashed.indexOf("accessories") === 0) {
                        if (hashed.indexOf("family") > -1) {
                            var firstTry = $context.find("#" + hashed + " > a");
                            // if we have the family we trigger click on it so we can extend element to open
                            if (firstTry.length > 0) firstTry.trigger("click").parent().parent().siblings().eq(0).trigger("click");
                            else $context.find("#" + hashed + ".category-title").trigger("click");
                        } else $context.find("#" + hashed + ".category-title").trigger("click");
                    } else $context.find("#" + hashed + ".category-title").trigger("click");
                }
            };
            familyListing.hide();
            processUrl(context);
        },
        processUrl: function(context) {
            var hashed = window.location.hash.slice(1), $context = $(context);
            if (hashed.length > 0) {
                if (hashed.indexOf("family") > -1 || hashed.indexOf("accessories") === 0) {
                    if (hashed.indexOf("family") > -1) {
                        var firstTry = $context.find("#" + hashed + " > a");
                        // if we have the family we trigger click on it so we can extend element to open
                        if (firstTry.length > 0) firstTry.trigger("click").parent().parent().siblings().eq(0).trigger("click");
                        else $context.find("#" + hashed + ".category-title").trigger("click");
                    } else $context.find("#" + hashed + ".category-title").trigger("click");
                } else $context.find("#" + hashed + ".category-title").trigger("click");
            }
        }
    };
})(jQuery, Drupal, drupalSettings);

})();
//# sourceMappingURL=treston_base_ajax_commands.js.map
